import { ICON_DEFAULT_COLOR } from '@constants/icons';
import { IconProps } from '@models/icons';

function DeleteCircleFill({
    color = ICON_DEFAULT_COLOR,
    size = 12, ...rest
}: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest}>
            <path
                d="M6 0C9.31376 0 11.9999 2.68627 12 6C12 9.31384 9.31384 12 6 12C2.68627 11.9999 0 9.31376 0 6C0.000125752 2.68635 2.68635 0.000125755 6 0Z"
                fill={color}/>
            <path d="M8.17485 4.00018L4.00031 8.17472" stroke="white" strokeWidth="1.2" strokeLinecap="round"/>
            <path d="M4.00044 4.00025L8.17498 8.17479" stroke="white" strokeWidth="1.2" strokeLinecap="round"/>
        </svg>
    );
}

export default DeleteCircleFill;
